module.exports = __webpack_public_path__ + "assets/img/24_423_big.5f47b998.jpg";